import { lazy } from 'react';

export const StatsPage = lazy(() => import('./StatsPage'));
